import { Transition } from '@headlessui/react'
import { IApprovedSubmissionName } from '../../pocketbase/PocketbaseMetadataService'
import { normalizeString } from '../../utils/stringUtils'

interface AdminSubmissionSuggestionsProps {
    query: string
    suggestions: IApprovedSubmissionName[]
    visible: boolean
}

export const AdminSubmissionSuggestions = ({ query, suggestions, visible }: AdminSubmissionSuggestionsProps) => {
    // Only show if query has some length and visible is true
    const show = visible && query.trim().length > 0

    const filteredItems = !show
        ? []
        : suggestions.filter((item) => normalizeString(item.name).toLowerCase().includes(normalizeString(query).toLowerCase()))

    if (!show) return null

    return (
        <div className="relative">
            <Transition
                show={show}
                enter="transition ease-out duration-100"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
            >
                <ul
                    className="absolute mt-1 max-h-[400px] w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg focus:outline-none sm:text-sm z-10 border border-gray-200"
                >
                    {filteredItems.length === 0 ? (
                        <li className="relative cursor-default select-none px-4 py-2 text-gray-500 italic">
                            No similar approved submissions found.
                        </li>
                    ) : (
                        filteredItems.map((item) => (
                            <li
                                key={item.id}
                                className="relative cursor-default select-none py-2 px-4 text-gray-500"
                            >
                                <span className="block truncate">
                                    {item.name}
                                </span>
                            </li>
                        ))
                    )}
                </ul>
            </Transition>
        </div>
    )
}
